const initialState = [];

const sizes = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'FILL_SIZES':
      return payload;

    default:
      return state;
  }
}

export default sizes;